import clsx, { type ClassValue } from 'clsx';

// Thin re-export of clsx so the rest of the app uses one import name.
// If conflict-resolving merges become a problem later we can swap in
// tailwind-merge without touching call sites.
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
